module.exports = __webpack_public_path__ + "static/bellnomina2.e5f4d649.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/bellnomina2.jpeg
// module id = 1259
// module chunks = 35783957827783